<template>
    <el-popover placement="left" trigger="click" class="help-button"
        v-if="$permissions.hasRight('dashboard.authoring-info.read')"
    >
        <template #reference>
            <a href="#" @click.prevent=""><i class="fas fa-info-circle"></i></a>
        </template>
        <p v-if="registration.degree.edition" class="text-small mb-1">
            <strong>{{ $t('dashboard.degree-edition') }}: </strong> {{ registration.degree.edition }}
        </p>
        <p v-if="registration.referents && registration.referents.length" class="text-small mb-1">
            <strong>{{ $t('dashboard.referent-instructors') }}: </strong> {{ referentNames }}
        </p>
        <p class="text-small mb-1">
            <strong>{{ $t('registrations.track-enabled') }}: </strong> {{ trackEnabled }}
        </p>
    </el-popover>
</template>

<script>
    export default {

        props: {
            registration: {
                type: Object,
            },
        },

        computed: {

            referentNames() {
                return this.registration.referents.map(referent => referent.name).join(', ')
            },

            trackEnabled() {
                return this.registration.track
                    ? this.$t('common.yes')
                    : this.$t('common.no')
            }
        },
    }
</script>

<style scoped>

    .help-button {
        top: 0.7rem;
        position: absolute;
        right: 1rem;
        font-size: 1.2rem;
    }
    .text-small {
        font-size: 0.9rem;
    }
    a {
        color: #a1aef7;
    }
    a:hover {
        color: #c9d1fb;
    }

</style>
